
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt/subscription-and-professional-services-agreement",
      function () {
        return require("private-next-pages/pt/subscription-and-professional-services-agreement/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt/subscription-and-professional-services-agreement"])
      });
    }
  